import { api } from '@/redux/api';
import { DeviceFunctionResponse, ExecuteDeviceFunctionQueryArg } from './types';

export * from './types';

const deviceFunctionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    executeDeviceFunction: builder.mutation<
      DeviceFunctionResponse,
      ExecuteDeviceFunctionQueryArg
    >({
      query: ({ deviceId, ...body }) => ({
        url: `/device/${deviceId}/functions`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, _error, queryArg) =>
        queryArg.function === 'enable-skill' &&
        result &&
        result.status >= 200 &&
        result.status < 300
          ? ['Devices']
          : [],
    }),
  }),
});

export const { useExecuteDeviceFunctionMutation } = deviceFunctionsApi;
